import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  MenuItem,
  Modal,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import {
  approveReimbursement,
  getReimbursementList,
} from "_controllers/officer";
import authAxios from "setups/axios";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Toaster } from "react-hot-toast";
import moment from "moment";
import { toastMessage } from "utils/toastMessage";
import GetAppIcon from "@mui/icons-material/GetApp";
import VisibilityIcon from "@mui/icons-material/Visibility";

const messageStyle = {
  width: "75%",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#F4F4F4",
  border: "none",
  boxShadow: 24,
  pt: 2,
  pb: 0,
  pl: 4,
  pr: 4,
  textAlign: "left",
  letterSpacing: 1,
};

const Main = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [remark, setRemark] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [expenseModal, setExpenseModal] = useState(false);
  const [expenseApproveModal, setExpenseApproveModal] = useState(false);
  const [expenseRejectModal, setExpenseRejectModal] = useState(false);
  const [billPreview, setBillPreview] = useState(false);

  const [expenseData, setExpenseData] = useState();

  useEffect(async () => {
    const reimbursementList = await getReimbursementList(currentPage);
    console.log("data", reimbursementList);
    setData(reimbursementList?.data);
    setMessage(reimbursementList?.message);
    setLoading(true);
    setTotalPages(reimbursementList?.totalPage ?? 1);
    setCurrentPage(reimbursementList?.currentPage);
  }, [message, currentPage]);

  const handelUpdate = async () => {
    toastMessage(response?.data?.message, "success");
  };

  const confirmDelete = async (id) => {
    console.log("idd", id);
    const response = await authAxios()({
      url: `/api/v1/holiday/${id}`,
      method: "DELETE",
    });
    setMessage(response?.data?.message);
    toastMessage(response?.data?.message, "success");
    setDeleteDialogOpen(false);
    setDeletedItemId("");
  };

  const handleChange = (e) => {
    setValues({
      ...Values,
      [e.target.name]: e.target.value.replace(/\s+/g, " "),
    });
  };

  const handleDelete = async (id) => {
    setDeleteDialogOpen(true);
    setDeletedItemId(id);
  };

  const handleCloseDialog = () => {
    setDeleteDialogOpen(false);
    setDeletedItemId("");
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handleRowClick = async (event, rowData) => {
    console.log("object", rowData);
    setExpenseData(rowData);
    setExpenseModal(true);
  };

  const approve = async (id) => {
    const approve = await approveReimbursement({ id, status: "Approved" });
    setMessage(approve.message);
    toastMessage(approve.message, "success");
    setExpenseApproveModal(false);
    setExpenseModal(false);
    setExpenseData();
  };

  const reject = async (id) => {
    const reject = await approveReimbursement({
      id,
      status: "Rejected",
      remark,
    });
    setMessage(reject.message);
    toastMessage(reject.message, "error");
    setExpenseRejectModal(false);
    setRemark("");
    setExpenseModal(false);
    setExpenseData();
  };

  const handleDownload = (data) => {
    console.log("download", data);
    data?.forEach((url, index) => {
      console.log("url", url);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      link.click();
      document.body.removeChild(link);
    });
  };

  const backgroundColor =
    expenseData?.status === "Approved" || expenseData?.status === "Rejected"
      ? "lightgrey"
      : "#40AF73";

  return (
    <>
      <div>
        <p
          style={{
            font: "25px",
            fontWeight: "bolder",
            color: "darkgrey",
          }}
        >
          Reimbursements
        </p>
      </div>
      {/* <Box position="relative" display="inline-flex">
        <CircularProgress variant="determinate" value={60} size={60} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="absolute"
        >
          <Typography variant="caption" component="div" color="textSecondary">
            {`${Math.round(60)}%`}
          </Typography>
        </Box>
      </Box> */}
      <div
        style={{
          width: "98%",
          border: "1.5px solid grey",
          marginBottom: "1rem",
        }}
      />
      {loading ? (
        <>
          <TableContainer component={Paper} style={{ marginTop: "3rem" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left" sx={{ fontWeight: "bolder" }}>
                    Date
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    User ID
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Category
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Sub Category
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Amount
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Approved By
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    View
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Status
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Attachments
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data?.length > 0 ? (
                  data?.map((d) => (
                    <TableRow key={d._id}>
                      <TableCell align="left">
                        {moment.utc(d?.reimbursementDate).format("YYYY-MM-DD")}
                      </TableCell>
                      <TableCell align="center">{d?.SAP_ID}</TableCell>
                      <TableCell align="center">{d?.category}</TableCell>
                      <TableCell align="center">{d?.subCategory}</TableCell>
                      <TableCell align="center">{d?.amount}</TableCell>
                      <TableCell align="center">{d?.approvedBy}</TableCell>
                      <TableCell
                        align="center"
                        onClick={(event) => handleRowClick(event, d)}
                        style={{ cursor: "pointer" }}
                      >
                        <VisibilityIcon />
                      </TableCell>
                      <TableCell align="center">
                        {
                          <div
                            style={{
                              // width: "89px",
                              height: "31px",
                              padding: "5px 15px",
                              borderRadius: "16px",
                              backgroundColor: `${
                                d?.status === "Approved"
                                  ? "rgba(64, 175, 115, 0.1)"
                                  : d?.status === "Rejected"
                                  ? "rgba(202, 94, 87, 0.1)"
                                  : "rgba(233, 181, 33, 0.1)"
                              }`,
                              color: `${
                                d?.status === "Approved"
                                  ? "#40AF73"
                                  : d?.status === "Rejected"
                                  ? "#CA5E57"
                                  : "#E9B521"
                              }`,
                            }}
                          >
                            {d?.status}
                          </div>
                        }
                      </TableCell>
                      <TableCell align="center">
                        <Button
                          onClick={() => handleDownload(d?.bills)}
                          target="_blank"
                        >
                          <GetAppIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <Box sx={{ textAlign: "left", pt: 1 }}>
                    <Typography variant="h6" sx={{ p: 1 }}>
                      No Reimbursements Available.
                    </Typography>
                  </Box>
                )}
              </TableBody>
            </Table>
            <Grid justifyContent={"center"} container p={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
              />
            </Grid>
          </TableContainer>
        </>
      ) : (
        <CircularProgress />
      )}

      <Modal
        open={expenseModal}
        onClose={() => {
          setExpenseModal(false);
          setExpenseData();
        }}
      >
        <Box sx={messageStyle}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "2.5rem 1rem",
            }}
          >
            <p
              style={{
                fontFamily: "Poppins",
                fontSize: "32px",
                fontWeight: "700",

                lineHeight: "34px",
                letterSpacing: "-0.01rem",
                textAlign: "left",
                padding: "1rem 0",
              }}
            >
              Expense Detail
            </p>
            <div
              style={{
                backgroundColor: "#FCFCFC",
                display: "flex",
                padding: "10px 0",
              }}
            >
              <div
                style={{
                  width: "35%",
                  padding: "1rem",

                  borderRight: "1px solid #ccc",
                }}
              >
                <p
                  style={{
                    color: "#000000",
                    fontFamily: "Poppins",
                    fontWeight: "600",
                  }}
                >
                  Description
                </p>
                <p
                  style={{
                    color: "#565A6D",
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    fontSize: "16px",
                    marginTop: "1rem",
                  }}
                >
                  {expenseData?.description ? expenseData?.description : "NA"}
                </p>
              </div>
              <div
                style={{
                  width: "65%",
                  padding: "1rem",
                  display: "flex",
                  flexDirection: "column",
                  marginLeft: "1rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "1rem",
                  }}
                >
                  <div style={{ width: "50%" }}>
                    <p
                      style={{
                        color: "#000000",
                        fontFamily: "Poppins",
                        fontWeight: "600",
                        marginBottom: "1rem",
                        fontSize: "18px",
                      }}
                    >
                      Submitted By
                    </p>
                    <TextField
                      value={`${expenseData?.SAP_ID}`}
                      name="title"
                      label="Employee ID"
                      variant="outlined"
                      disabled
                    />
                  </div>
                  <div>
                    <p
                      style={{
                        color: "#000000",
                        fontFamily: "Poppins",
                        fontWeight: "600",
                        marginBottom: "1rem",
                        fontSize: "18px",
                      }}
                    >
                      Amount to be reimbursed
                    </p>
                    <p
                      style={{
                        color: "#FDBC00",
                        fontFamily: "Poppins",
                        fontWeight: "500",
                        marginBottom: "1rem",
                        fontSize: "22px",
                      }}
                    >
                      ₹ {`${expenseData?.amount}`}
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    paddingTop: "1rem",
                  }}
                >
                  <div style={{ width: "50%" }}>
                    <p
                      style={{
                        color: "#000000",
                        fontFamily: "Poppins",
                        fontWeight: "600",
                        marginBottom: "1rem",
                        fontSize: "18px",
                      }}
                    >
                      Submitted On
                    </p>
                    <p
                      style={{
                        color: "#4D4D4D",
                        fontFamily: "Poppins",
                        fontWeight: "600",
                        fontSize: "16px",
                      }}
                    >
                      {moment
                        .utc(expenseData?.reimbursementDate)
                        .format("DD MMM YYYY")}
                    </p>
                  </div>
                  <div>
                    <p
                      style={{
                        color: "#000000",
                        fontFamily: "Poppins",
                        fontWeight: "600",
                        marginBottom: "1rem",
                        fontSize: "18px",
                      }}
                    >
                      Status
                    </p>
                    <div
                      style={{
                        color: "#FDBC00",
                        width: "120px",
                        height: "35px",
                        borderRadius: "16px",
                        backgroundColor: `${
                          expenseData?.status === "Approved"
                            ? "rgba(64, 175, 115, 0.1)"
                            : expenseData?.status === "Rejected"
                            ? "rgba(202, 94, 87, 0.1)"
                            : "rgba(233, 181, 33, 0.1)"
                        }`,
                        color: `${
                          expenseData?.status === "Approved"
                            ? "#40AF73"
                            : expenseData?.status === "Rejected"
                            ? "#CA5E57"
                            : "#E9B521"
                        }`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "5px 15px",
                      }}
                    >
                      {expenseData?.status}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                marginBottom: "1rem",
                display: "flex",
                height: "37vh",
              }}
            >
              <div style={{ width: "65%" }}>
                <div
                  style={{
                    margin: "1rem 0",
                    backgroundColor: "#FCFCFC",
                    padding: "10px",
                    lineHeight: "36px",
                  }}
                >
                  <p
                    style={{
                      color: "#000000",
                      fontFamily: "Poppins",
                      fontWeight: "600",
                      margin: "0 0 1rem 1rem",
                      fontSize: "18px",
                    }}
                  >
                    Summary
                  </p>
                  <table
                    style={{
                      width: "100%",
                      padding: "0 10px",
                    }}
                  >
                    <tr>
                      <td
                        style={{
                          color: "#464E5F",
                          fontFamily: "Poppins",
                          fontWeight: "600",
                          fontSize: "16px",
                        }}
                      >
                        Date
                      </td>
                      <td
                        style={{
                          color: "#464E5F",
                          fontFamily: "Poppins",
                          fontWeight: "600",
                          fontSize: "16px",
                        }}
                      >
                        Category
                      </td>
                      <td
                        style={{
                          color: "#464E5F",
                          fontFamily: "Poppins",
                          fontWeight: "600",
                          fontSize: "16px",
                        }}
                      >
                        Sub Category
                      </td>
                      <td
                        style={{
                          color: "#464E5F",
                          fontFamily: "Poppins",
                          fontWeight: "600",
                          fontSize: "16px",
                        }}
                      >
                        Receipt
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          color: "#464E5F",
                          fontFamily: "Poppins",
                          fontWeight: "600",
                          fontSize: "18px",
                        }}
                      >
                        {moment
                          .utc(expenseData?.reimbursementDate)
                          .format("DD MMM YYYY")}
                      </td>
                      <td
                        style={{
                          color: "#464E5F",
                          fontFamily: "Poppins",
                          fontWeight: "600",
                          fontSize: "18px",
                        }}
                      >
                        {expenseData?.category}
                      </td>
                      <td
                        style={{
                          color: "#464E5F",
                          fontFamily: "Poppins",
                          fontWeight: "600",
                          fontSize: "18px",
                        }}
                      >
                        {expenseData?.subCategory}
                      </td>
                      <td
                        style={{
                          color: "#464E5F",
                          fontFamily: "Poppins",
                          fontWeight: "600",
                          fontSize: "18px",
                        }}
                        onClick={(e) => handleDownload(expenseData?.bills)}
                      >
                        <GetAppIcon style={{ cursor: "pointer" }} />
                      </td>
                    </tr>
                  </table>
                </div>
                <div
                  style={{
                    backgroundColor: "#FCFCFC",
                    padding: "10px",
                    lineHeight: "36px",
                  }}
                >
                  <p
                    style={{
                      color: "#000000",
                      fontFamily: "Poppins",
                      fontWeight: "600",
                      margin: "0 0 1rem 1rem",
                      fontSize: "18px",
                    }}
                  >
                    Take Action
                  </p>
                  <div style={{ margin: "1rem" }}>
                    <button
                      style={{
                        backgroundColor: "#D1D1D1",
                        padding: "7px 45px",
                        borderRadius: "6px",
                        height: "38px",
                        fontWeight: "500",
                        marginRight: "2rem",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                      disabled={
                        expenseData?.status === "Approved" ||
                        expenseData?.status === "Rejected"
                          ? true
                          : false
                      }
                      onClick={() => setExpenseRejectModal(true)}
                    >
                      Reject
                    </button>
                    <button
                      style={{
                        // backgroundColor: "#40AF73",
                        backgroundColor: backgroundColor,
                        // expenseData?.status === "Rejected"}`,
                        padding: "7px 45px",
                        borderRadius: "6px",
                        height: "38px",
                        fontWeight: "500",
                        color: "#FFFFFF",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                      onClick={() => setExpenseApproveModal(true)}
                      disabled={
                        expenseData?.status === "Approved" ||
                        expenseData?.status === "Rejected"
                          ? true
                          : false
                      }
                    >
                      Approve
                    </button>
                  </div>
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "darkgrey",
                  width: "35%",
                  height: "auto",
                  margin: "1rem 0 0 1rem",
                  padding: "1rem",
                }}
              >
                <img
                  src={expenseData?.bills[0]}
                  alt="image"
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={expenseApproveModal}
        onClose={() => {
          setExpenseApproveModal(false);
        }}
      >
        <Box
          sx={{
            width: "40%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#fff",
            border: "none",
            boxShadow: 24,
            p: "2rem",
            textAlign: "left",
            letterSpacing: 1,
            borderRadius: "8px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p
              style={{
                fontFamily: "Inter",
                fontSize: "20px",
                fontWeight: "600",
                lineHeight: "24px",
                textAlign: "left",
                // padding: "1rem 0",
              }}
            >
              Sure you want to approve?
            </p>
            <p
              style={{ color: "#54595E", fontWeight: "400", marginTop: "1rem" }}
            >
              This action will approve the reimbursement.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginTop: "1.5rem",
              }}
            >
              <button
                style={{
                  backgroundColor: "rgba(209, 209, 209, 1)",
                  padding: "14px 20px",
                  borderRadius: "8px",
                  height: "44px",
                  width: "180px",
                  border: "1px solid #3273F6",
                  color: "#3273F6",
                }}
                onClick={() => setExpenseApproveModal(false)}
              >
                No, cancel
              </button>
              <button
                style={{
                  backgroundColor: "#3273F6",
                  padding: "14px 20px",
                  borderRadius: "8px",
                  height: "44px",
                  width: "180px",
                  color: "#ffffff",
                }}
                onClick={() => approve(expenseData?._id)}
              >
                Yes, confirm
              </button>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={expenseRejectModal}
        onClose={() => {
          setExpenseRejectModal(false);
        }}
      >
        <Box
          sx={{
            width: "40%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#fff",
            border: "none",
            boxShadow: 24,
            p: "2rem",
            textAlign: "left",
            letterSpacing: 1,
            borderRadius: "8px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p
              style={{
                fontFamily: "Inter",
                fontSize: "18px",
                fontWeight: "500",
                lineHeight: "24px",
                textAlign: "left",
                fontFamily: "Public Sans",
                // padding: "1rem 0",
              }}
            >
              Please share the reason for rejecting the reimbursement.
            </p>
            <p
              style={{
                color: "#54595E",
                fontWeight: "400",
                marginTop: "1rem",
                fontSize: "15px",
                fontFamily: "Public Sans",
              }}
            >
              This would help employees understand why their reimbursement was
              rejected.
            </p>
            <TextField
              sx={{ mt: 3 }}
              onChange={(e) => setRemark(e.target.value)}
              name="remark"
              value={remark}
              label="Text here"
              variant="outlined"
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1.5rem",
                height: "2.5rem",
              }}
            >
              <button
                style={{
                  backgroundColor: "rgba(168, 170, 174, 0.16)",
                  padding: "10px 30px",
                  borderRadius: "6px",
                  fontWeight: "500",
                  color: "#A8AAAE",
                }}
                onClick={() => setExpenseRejectModal(false)}
              >
                Cancel
              </button>
              <button
                style={{
                  backgroundColor: "#3273F6",
                  padding: "10px 30px",
                  borderRadius: "6px",
                  fontWeight: "500",
                  color: "#ffffff",
                  marginLeft: "1rem",
                }}
                onClick={() => reject(expenseData?._id)}
              >
                Submit
              </button>
            </div>
          </div>
        </Box>
      </Modal>

      {/* <Modal
        open={expenseRejectModal}
        onClose={() => {
          setExpenseRejectModal(false);
        }}
      >
        <Box
          sx={{
            width: "40%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#fff",
            border: "none",
            boxShadow: 24,
            p: "2rem",
            textAlign: "left",
            letterSpacing: 1,
            borderRadius: "8px",
          }}
        >
          <div>
            {expenseData?.bills.map((n, i) => {
              return (
                <div
                  style={{ border: "1px solid black", marginBottom: "10px" }}
                  key={i}
                >
                  <img src={n} alt="image" style={{ width: "100%" }} />
                </div>
              );
            })}
          </div>
        </Box>
      </Modal> */}
    </>
  );
};

const Reimbursement = () => {
  return (
    <AccessController roles={["RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default Reimbursement;
